import { APIClient } from "./axiosClient";
const api = new APIClient();

const path = "/notices";
const applicationApi = {
  getNotice(params: any): Promise<any> {
    const url = `${path}`;
    return api.get(url, params);
  },
  getSummary(params: any): Promise<any> {
    const url = `${path}/summary`;
    return api.get(url, params);
  },
  getDetails(id: any): Promise<any> {
    const url = `${path}/${id}`;
    return api.get(url);
  },
  updateDetail(id: any, body: any): any {
    const url = `${path}/${id}`;
    return api.put(url, body);
  },
  postNotice(dataForm: any): Promise<any> {
    const url = `${path}`;
    return api.post(url, dataForm);
  },

  putNotice(id: any, dataForm: any): Promise<any> {
    const url = `${path}/${id}`;
    return api.put(url, dataForm);
  },

  deleteNotice(id: any) {
    return api.delete(`${path}/${id}`);
  },
};

export default applicationApi;
